'use client';

import { c as _c } from "react/compiler-runtime";
import { CardText } from '@morpho-org/ui-v6/server';
const ApyDataListPerformanceError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-sm flex w-[100%] flex-wrap"><CardText height="132px" text="An error occurred" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ApyDataListPerformanceError;